module.exports = __webpack_public_path__ + "img/SubmitSettingDialog.cb04e148.png";